import { Component } from '@angular/core';

@Component({
  selector: 'studio-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {}
